import React from 'react'
import "./gernralgames/GeneralGamesDevelopment.css";

function GameAdminControl() {
    return (
        <div className="Admin-control-main-container">
            <h2 style={{ color: "#B174CC", fontWeight: "700" }} className="ourservice-titles-new">Online Ludo Game Features</h2>
            <div style={{ marginTop: "30px" }} className="Admin-control-inner-container">
                <div className="a-card card-discover card1 col-md-3">
                    <div className="card-icon-title-wrapper">
                        <div className="card__icon pb-1">
                            <div className="icon__wrapper">
                                <img src="./images/Play-with-your-friends.webp" alt="Play with your friends" />
                            </div>
                        </div>
                        <h1 className="card__title fs-4 g-text">
                            Play with your friends
                        </h1>
                    </div>
                    <p className="card__description">
                        Play Ludo using your skills and win to earn real cash. Use
                        your ludo expertise to earn real money instead of just using
                        it to pass time.
                    </p>
                </div>
                <div className="a-card card-discover card1 col-md-3">
                    <div className="card-icon-title-wrapper">
                        <div className="card__icon pb-1">
                            <div className="icon__wrapper">
                                <img
                                    src="./images/Play-Online-with-real-money.webp"
                                    alt="Play Online with real money"
                                />
                            </div>
                        </div>
                        <h1 className="card__title fs-4 g-text">
                            Play Online with real money
                        </h1>
                    </div>
                    <p className="card__description">
                        Play Ludo using your skills and win to earn real cash. Use
                        your ludo expertise to earn real money instead of just using
                        it to pass time.
                    </p>
                </div>

                <div className="a-card card-discover col-md-3">
                    <div className="card-icon-title-wrapper">
                        <div className="card__icon pb-1">
                            <div className="icon__wrapper">
                                <img src="./images/Play-with-Computer.webp" alt="Play with Computer" />
                            </div>
                        </div>
                        <h1 className="card__title fs-4 g-text">
                            Play with Computer
                        </h1>
                    </div>
                    <p className="card__description">
                        Play Ludo using your skills and win to earn real cash. Use
                        your ludo expertise to earn real money instead of just using
                        it to pass time.
                    </p>
                </div>

                <div className="a-card card-discover col-md-3">
                    <div className="card-icon-title-wrapper">
                        <div className="card__icon pb-1">
                            <div className="icon__wrapper">
                                <img src="./images/Play-with-timer.webp" alt="Play with timer" />
                            </div>
                        </div>
                        <h1 className="card__title fs-4 g-text">Play with timer</h1>
                    </div>
                    <p className="card__description">
                        Play Ludo using your skills and win to earn real cash. Use
                        your ludo expertise to earn real money instead of just using
                        it to pass time.
                    </p>
                </div>
            </div>
            <div className="Admin-control-inner-container">
                <div className="a-card card-discover card1 col-md-3">
                    <div className="card-icon-title-wrapper">
                        <div className="card__icon pb-1">
                            <div className="icon__wrapper ">
                                <img src="./images/Daily-Bonus.webp" alt='Daily Bonus' />
                            </div>
                        </div>
                        <h1 className="card__title fs-4 g-text">Daily Bonus</h1>
                    </div>
                    <p className="card__description">
                        Play Ludo using your skills and win to earn real cash. Use
                        your ludo expertise to earn real money instead of just using
                        it to pass time.
                    </p>
                </div>
                <div className="a-card card-discover card1 col-md-3">
                    <div className="card-icon-title-wrapper">
                        <div className="card__icon pb-1">
                            <div className="icon__wrapper ">
                                <img src="./images/Live-Chat.webp" alt='Live Chat' />
                            </div>
                        </div>
                        <h1 className="card__title fs-4 g-text"> Live Chat</h1>
                    </div>
                    <p className="card__description">
                        Play Ludo using your skills and win to earn real cash. Use
                        your ludo expertise to earn real money instead of just using
                        it to pass time.
                    </p>
                </div>

                <div className="a-card card-discover col-md-3">
                    <div className="card-icon-title-wrapper">
                        <div className="card__icon pb-1">
                            <div className="icon__wrapper">
                                <img src="./images/Refer-&-Earn.webp" alt='Refer & Earn' />
                            </div>
                        </div>
                        <h1 className="card__title fs-4 g-text">Refer & Earn</h1>
                    </div>
                    <p className="card__description">
                        Play Ludo using your skills and win to earn real cash. Use
                        your ludo expertise to earn real money instead of just using
                        it to pass time.
                    </p>
                </div>

                <div className="a-card card-discover col-md-3">
                    <div className="card-icon-title-wrapper">
                        <div className="card__icon pb-1">
                            <div className="icon__wrapper ">
                                <img
                                    src="./images/Quick-Deposit-&-Withdraw-money.webp"
                                    alt='Quick Deposit & Withdraw money'
                                />
                            </div>
                        </div>
                        <h1 className="card__title fs-4 g-text">
                            {" "}
                            Quick Deposit & Withdraw money
                        </h1>
                    </div>
                    <p className="card__description">
                        Play Ludo using your skills and win to earn real cash. Use
                        your ludo expertise to earn real money instead of just using
                        it to pass time.
                    </p>
                </div>
            </div>
            <div className="Admin-control-inner-container">
                <div className="a-card card-discover card1 col-md-3">
                    <div className="card-icon-title-wrapper">
                        <div className="card__icon pb-1">
                            <div className="icon__wrapper ">
                                <img src="./images/Game-history.webp" alt='Game History' />
                            </div>
                        </div>
                        <h1 className="card__title fs-4 g-text">Game History</h1>
                    </div>
                    <p className="card__description">
                        Play Ludo using your skills and win to earn real cash. Use
                        your ludo expertise to earn real money instead of just using
                        it to pass time.
                    </p>
                </div>
                <div className="a-card card-discover card1 col-md-3">
                    <div className="card-icon-title-wrapper">
                        <div className="card__icon pb-1">
                            <div className="icon__wrapper ">
                                <img src="./images/Auto-move.webp" alt='Auto move' />
                            </div>
                        </div>
                        <h1 className="card__title fs-4 g-text"> Auto move</h1>
                    </div>
                    <p className="card__description">
                        Play Ludo using your skills and win to earn real cash. Use
                        your ludo expertise to earn real money instead of just using
                        it to pass time.
                    </p>
                </div>

                <div className="a-card card-discover col-md-3">
                    <div className="card-icon-title-wrapper">
                        <div className="card__icon pb-1">
                            <div className="icon__wrapper">
                                <img
                                    src="./images/Deposit-&-withdraw-history.webp"
                                    alt=' Deposit & withdraw history'
                                />
                            </div>
                        </div>
                        <h1 className="card__title fs-4 g-text">
                            Deposit & withdraw history
                        </h1>
                    </div>
                    <p className="card__description">
                        Play Ludo using your skills and win to earn real cash. Use
                        your ludo expertise to earn real money instead of just using
                        it to pass time.
                    </p>
                </div>

                <div className="a-card card-discover col-md-3">
                    <div className="card-icon-title-wrapper">
                        <div className="card__icon pb-1">
                            <div className="icon__wrapper ">
                                <img src="./images/Live-Support-feature.webp" alt='Live Support features' />
                            </div>
                        </div>
                        <h1 className="card__title fs-4 g-text">
                            Live Support features
                        </h1>
                    </div>
                    <p className="card__description">
                        Play Ludo using your skills and win to earn real cash. Use
                        your ludo expertise to earn real money instead of just using
                        it to pass time.
                    </p>
                </div>
            </div>
            <div className="Admin-control-inner-container">
                <div className="a-card card-discover card1 col-md-3">
                    <div className="card-icon-title-wrapper">
                        <div className="card__icon pb-1">
                            <div className="icon__wrapper ">
                                <img src="./images/Mobile-and-email-login.webp" alt=' Mobile and email login' />
                            </div>
                        </div>
                        <h1 className="card__title fs-4 g-text">
                            Mobile and email login
                        </h1>
                    </div>
                    <p className="card__description">
                        Play Ludo using your skills and win to earn real cash. Use
                        your ludo expertise to earn real money instead of just using
                        it to pass time.
                    </p>
                </div>
                <div className="a-card card-discover card1 col-md-3">
                    <div className="card-icon-title-wrapper">
                        <div className="card__icon pb-1">
                            <div className="icon__wrapper ">
                                <img src="./images/Multiple-Payment-Option.webp" alt='Multiple Payment Option' />
                            </div>
                        </div>
                        <h1 className="card__title fs-4 g-text">
                            Multiple Payment Option
                        </h1>
                    </div>
                    <p className="card__description">
                        Play Ludo using your skills and win to earn real cash. Use
                        your ludo expertise to earn real money instead of just using
                        it to pass time.
                    </p>
                </div>

                <div className="a-card card-discover col-md-3">
                    <div className="card-icon-title-wrapper">
                        <div className="card__icon pb-1">
                            <div className="icon__wrapper">
                                <img src="./images/2-and-4-player-system.webp" alt='2&4 player system' />
                            </div>
                        </div>
                        <h1 className="card__title fs-4 g-text">
                            2&4 player system
                        </h1>
                    </div>
                    <p className="card__description">
                        Play Ludo using your skills and win to earn real cash. Use
                        your ludo expertise to earn real money instead of just using
                        it to pass time.
                    </p>
                </div>

                <div className="a-card card-discover col-md-3">
                    <div className="card-icon-title-wrapper">
                        <div className="card__icon pb-1">
                            <div className="icon__wrapper ">
                                <img src="./images/Tournament-system.webp" alt=' Tournament system' />
                            </div>
                        </div>
                        <h1 className="card__title fs-4 g-text">
                            {" "}
                            Tournament system
                        </h1>
                    </div>
                    <p className="card__description">
                        Play Ludo using your skills and win to earn real cash. Use
                        your ludo expertise to earn real money instead of just using
                        it to pass time.
                    </p>
                </div>
            </div>

        </div>
    )
}

export default GameAdminControl;